import { atom } from "jotai";

import { DiningBookingWizardDataAtom } from "@/features/BookingWizard/DiningBookingWizard/atoms/stores";

export const updateDiningNotes = atom(null, (get, set, notes: string) => {
  const diningData = get(DiningBookingWizardDataAtom);
  if (!diningData) {
    return;
  }

  set(DiningBookingWizardDataAtom, {
    ...diningData,
    notes,
  });
});
